import React from 'react'
// hooks
import { useShowModal } from 'hooks/index'
// constants
import { Modals } from 'constants/index'
// views
import { ScheduleReviewIcon, IconWrapper } from 'components/Modals/CreateScheduledReviewModal/views'
// context
import { ObjectiveContext } from 'context/EntityContext'

interface IIncomingProps {
  entity: any
}

const ScheduleReviewLink: React.FC<IIncomingProps> = ({ entity }) => {
  const { planTypeLevel } = React.useContext(ObjectiveContext)

  const { showModal } = useShowModal({ modalType: Modals.SCHEDULE_REVIEW_MODAL })

  const showScheduleReviewModal = () => showModal({ entity, levelId: planTypeLevel?.id })

  return (
    <IconWrapper data-testid='schedule-review' onClick={showScheduleReviewModal}>
      <ScheduleReviewIcon /> Schedule Review
    </IconWrapper>
  )
}

export default ScheduleReviewLink
